import * as React from 'react';
import {
  DialogContent,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';

import { CDialog, CDialogTitle, CDialogActions, CButton } from '../components/common/Modal';

const CHART_TYPES = ['Bar', 'Line', 'Pie'];

export default function VisualizationSetupModal({ open, columns, result, onClose, onSubmit }) {
  const [xField, setXField] = React.useState('');
  const [dataField, setDataField] = React.useState('');
  const [chartType, setChartType] = React.useState('Bar');

  React.useEffect(() => {
    if (open && columns.length > 0) {
      // Pick x-axis as the column with the most distinct values (avoids collapsing all rows to one point)
      let bestX = columns[0];
      if (result && result.length > 0) {
        let maxDistinct = 0;
        columns.forEach(col => {
          const distinct = new Set(result.map(r => String(r[col]))).size;
          if (distinct > maxDistinct) {
            maxDistinct = distinct;
            bestX = col;
          }
        });
      }
      setXField(bestX);
      // Default data to first column that isn't the x-axis
      const defaultData = columns.find(c => c !== bestX) ?? bestX;
      setDataField(defaultData);
      setChartType('Bar');
    }
  }, [open, columns, result]);

  const handleOk = () => {
    if (!xField || !dataField) return;
    onSubmit({ xField, dataField, chartType });
  };

  return (
    <CDialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <CDialogTitle>Visualization Setup</CDialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: '1rem', pt: '1.25rem !important' }}>
        <FormControl size="small" fullWidth>
          <InputLabel>Select field for X Axis</InputLabel>
          <Select
            value={xField}
            label="Select field for X Axis"
            onChange={(e) => setXField(e.target.value)}
          >
            {columns.map(col => (
              <MenuItem key={col} value={col}>{col}</MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl size="small" fullWidth>
          <InputLabel>Select field for Data</InputLabel>
          <Select
            value={dataField}
            label="Select field for Data"
            onChange={(e) => setDataField(e.target.value)}
          >
            {columns.map(col => (
              <MenuItem key={col} value={col}>{col}</MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl size="small" fullWidth>
          <InputLabel>Visualization Type</InputLabel>
          <Select
            value={chartType}
            label="Visualization Type"
            onChange={(e) => setChartType(e.target.value)}
          >
            {CHART_TYPES.map(t => (
              <MenuItem key={t} value={t}>{t}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
      <CDialogActions>
        <CButton onClick={onClose}>Cancel</CButton>
        <CButton onClick={handleOk} disabled={!xField || !dataField}>OK</CButton>
      </CDialogActions>
    </CDialog>
  );
}
